import { render } from 'preact';
import { html } from 'htm/preact';
import SearchEngineWidget from './search-engine-widget';

function parseDataset({ input = '', fallback }) {
  try {
    return JSON.parse(input);
  } catch (err) {
    // Do nothing.
  }

  return fallback;
}

async function mount({ rootElement = null }) {
  // const preact = await import('preact');
  // const htm = await import('htm/preact');

  const {
    translations, language, searchQuery,
  } = rootElement.dataset;
  const container = rootElement.querySelector('.search-engine');

  const options = {
    translations: parseDataset({ input: translations, fallback: [] }),
    language,
    searchQuery,
  };

  render(html`
    <${SearchEngineWidget}
      translations=${options.translations}
      language=${options.language}
      searchQuery=${options.searchQuery}
    />`, container);
}

function init() {
  const blocks = document.querySelectorAll('.section--search-engine');

  [...blocks].forEach((block) => {
    mount({ rootElement: block });
  });
}

export default init;
